import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import 'CssFolder/chart.scss';
import languageModel from "../../../models/language.model";

export default function ToDoComplusoryChartComponent() {
    let data;
    let chartId = 'xychart_todo_complusory';
    let root;

    let onComplusoryTaskChartDataChanged = (_data) => {
        if (_data) {
            data = _data;
        }
        am5.array.each(am5.registry.rootElements, function (root) {
            //console.log(chartId);
            //console.log(root);
            if (root && root.dom.id == chartId) {
                root.dispose();
            }
        });
        initChart();
    }

    let initChart = () => {
        root?.dispose(); // dispose any pre-existing roots
        
        // Create root element
        // https://www.amcharts.com/docs/v5/getting-started/#Root_element
        root = am5.Root.new(chartId);

        // Set themes
        // https://www.amcharts.com/docs/v5/concepts/themes/
        root.setThemes([
            am5themes_Animated.new(root)
        ]);

        // Create chart
        // https://www.amcharts.com/docs/v5/charts/xy-chart/
        var chart = root.container.children.push(am5xy.XYChart.new(root, {
            panX: true,
            panY: false,
            wheelX: "panX",
            wheelY: "zoomX",
            layout: root.verticalLayout
        }));

        chart.children.unshift(am5.Label.new(root, {
            text: "Mandatory Task",
            fontSize: 20,
            fontWeight: "500",
            textAlign: "center",
            x: am5.percent(50),
            centerX: am5.percent(50),
            paddingTop: 0,
            paddingBottom: 10
        }));

        chart.get("colors").set("colors", [
            am5.color(0x1E85F1),
            am5.color(0x84E0BE)
        ]);

        // Add scrollbar
        // https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/
        /*
        chart.set("scrollbarX", am5.Scrollbar.new(root, {
          orientation: "horizontal"
        }));
        */

        // Create axes
        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
        var xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
            categoryField: "period",
            renderer: am5xy.AxisRendererX.new(root, {
                cellStartLocation: 0.1,
                cellEndLocation: 0.9,
                minGridDistance: 30
            }),
            // tooltip: am5.Tooltip.new(root, {
            //     themeTags: ["axis"],
            //     animationDuration: 200
            // })
        }));

        let xRenderer = xAxis.get("renderer");
        xRenderer.grid.template.setAll({
            stroke: am5.color(0xFFFFFF),
            strokeWidth: 1
        });

        xRenderer.labels.template.setAll({
            fontSize: 12,
        });

        xAxis.data.setAll(data);

        var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
            min: 0,
            maxPrecision: 0,
            renderer: am5xy.AxisRendererY.new(root, {})
        }));

        let yRenderer = yAxis.get("renderer");
        yRenderer.grid.template.setAll({
            stroke: am5.color(0xFFFFFF),
            strokeWidth: 1
        });

        yRenderer.labels.template.setAll({
            fontSize: 12,
        });

        // Add series
        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/

        var series0 = chart.series.push(am5xy.ColumnSeries.new(root, {
            name: languageModel.getText("LT00000314", "Total Mandatory Task"),
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "total",
            categoryXField: "period",
            //clustered: false,
            tooltip: am5.Tooltip.new(root, {
                labelText: "Total: {valueY}"
            })
        }));

        series0.columns.template.setAll({
            width: am5.percent(100),
            tooltipY: 0
        });


        series0.data.setAll(data);


        var series1 = chart.series.push(am5xy.ColumnSeries.new(root, {
            name: languageModel.getText("LT00000315", "Completed Mandatory Task"),
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "complete",
            categoryXField: "period",
            //clustered: true,
            tooltip: am5.Tooltip.new(root, {
                labelText: "Completed: {valueY}"
            })
        }));

        series1.columns.template.setAll({
            width: am5.percent(100),
            tooltipY: 0
        });

        series1.data.setAll(data);

        var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));

        cursor.lineX.setAll({
            visible: false
        });

        cursor.lineY.setAll({
            visible: false
        });

        var legend = chart.children.push(am5.Legend.new(root, {
            centerX: am5.p50,
            x: am5.p50
        }));

        legend.labels.template.setAll({
            fontSize: 12,
            fontWeight: "300"
        });
        
        legend.data.push(series0);
        legend.data.push(series1);
        // Make stuff animate on load
        // https://www.amcharts.com/docs/v5/concepts/animations/
        chart.appear(1000, 100);
        series0.appear();
        series1.appear();
    }

    return {
        oninit: function (vnode) {
        },
        oncreate: function (vnode) {
            if (vnode.attrs.events) {
                vnode.attrs.events.onComplusoryTaskChartDataChanged = onComplusoryTaskChartDataChanged;
            }
            if (vnode.attrs.data) {
                //console.log('vnode.attrs.data: ', vnode.attrs.data);
                data = vnode.attrs.data;
                initChart();
            }
        },
        view: function (vnode) {
            return m('.chart', {
                id: chartId,
            });
        }
    }
}